import { render, staticRenderFns } from "./wxzj.vue?vue&type=template&id=3ade5fd2&scoped=true"
import script from "./wxzj.vue?vue&type=script&lang=js"
export * from "./wxzj.vue?vue&type=script&lang=js"
import style0 from "./wxzj.vue?vue&type=style&index=0&id=3ade5fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade5fd2",
  null
  
)

export default component.exports